import { DefaultTheme } from "styled-components";

const lightTheme: DefaultTheme = {
  body: "#f1f1f1",
  text: "#121620",
};

export { lightTheme };
